let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3ORi1")).then(() => parcelRequire('kjLAT'));